import { Button, Col, Divider, Flex, Row, Spin } from "antd";
import { getWebSearch } from "api/search.api";
import React, { useEffect, useRef, useState } from "react";
import { calculateDuration, getSubstring } from "utils";
import clockStopWatch from "../../images/clockstopwatch.svg";
import { useNavigate } from "react-router-dom";
import CandidateAddWebSearchForm from "./CandidateAddWebSearchForm";
import TooltipWrapper from "./TooltipWrapper";
import trashIcon from "../../images/trash.svg";
import { editCandidate } from "api/candidate.api";
import { useDispatch } from "react-redux";
import { creditsRefreshChanger } from "store/slices/refresh.slice";

interface WebSearchProps {
    clickedProfile: number;
    isEditedWebSearch?: boolean;
    editorName: string;
    setRefresh: React.Dispatch<React.SetStateAction<boolean>>;
    loading: boolean;
    setError: React.Dispatch<React.SetStateAction<string | null>>;
    candidateNotes?: any
    tooltipText?: string;
}

interface WebSearchData {
    webpages: any[];
}

const WebSearch: React.FC<WebSearchProps> = ({ clickedProfile, isEditedWebSearch, editorName, setRefresh, loading, setError, candidateNotes, tooltipText }) => {
    const dispatch = useDispatch();
    // const [loading, setLoading] = useState<boolean>(false);
    const [candidateNote, setCandidateNote] = useState<any[]>([]);
    const [webSearchData, setWebSearchData] = useState<WebSearchData | null>(null);
    const [deletedWebSearchData, setDeletedWebSearchData] = useState<any[]>([]);
    const [isAddWebSearch, setIsAddWebSearch] = useState<boolean>(false);
    const formRef = useRef<HTMLDivElement>(null);

    // const getEditedField = (key: string, fallbackKey: string) => {
    //     const values = candidateNotes?.map((note: any) => note.custom_fields?.[key]).filter(Boolean) || [];
    //     console.log("Value ::: ", values);
    //     console.log("setWebSearchData ::: ", webSearchData);
    //     return values.length > 0 ? values.flatMap((group: any) => group.flatMap((item: any) => item.webpages || [])) : webSearchData || (key === "web_search" ? [] : "");
    // };
    const getWebSearchToolTip = (exp: any) => {
        const item = exp;
        if (item) {
            console.log("Item 76: ", item);
            if (item?.modified_date) {
                const date = new Date(item?.modified_date).toISOString()
                    .split("T")[0];
                return `${item.is_edited ? "Edited" : "Added"} by ${item.edited_by} on ${date}`;
            }
            return;
        }
        return;
    };
    const getEditedField = (key: string, fallbackKey: string) => {
        const values = candidateNote
            ?.map((note: any) => note.custom_fields?.[key])
            .filter(Boolean) ?? []; // Ensure an empty array if undefined

        console.log("Value ::: ", values);
        console.log("setWebSearchData ::: ", webSearchData);

        const extractedWebpages = values.flatMap((group: any) =>
            Array.isArray(group)
                ? group.flatMap((item: any) =>
                    (item.webpages ?? []).filter((webpage: any) => !webpage.is_deleted)
                )
                : []
        );

        const extractedDeleteWebpages = values.flatMap((group: any) =>
            Array.isArray(group)
                ? group.flatMap((item: any) =>
                    (item.webpages ?? []).filter((webpage: any) => webpage.is_deleted)
                )
                : []
        );

        if (extractedDeleteWebpages.length > 0) {
            setDeletedWebSearchData(extractedDeleteWebpages);
        }

        return extractedWebpages.length > 0 ? extractedWebpages : webSearchData ?? (key === "web_search" ? [] : "");
    };

    const [getEditedWebSearch, setGetEditedWebSearch] = useState<Array<any>>([]);


    // const editedWebSearch = getEditedField("web_search", "web_search");
    // const getEditedWebSearch = [
    //     ...(webSearchData && Array.isArray(webSearchData.webpages) ? webSearchData.webpages : []),
    //     ...(Array.isArray(editedWebSearch) ? editedWebSearch : [])
    // ];

    const getWebSearchResult = async () => {
        try {
            setRefresh(true);
            const response = await getWebSearch(clickedProfile);
            setWebSearchData(response?.web_search[0] || []);
        } catch (error) {
            console.error("Error fetching web search data:", error);
        } finally {
            setRefresh(false);
            setIsAddWebSearch(false);
        }
    };

    const handleDeleteWebSearch = async (webSearch: any) => {
        const candidateWebSearchPayload = {
            custom_fields: {
                web_search: [{
                    webpages: [
                        {
                            engine: webSearch.engine,
                            url: webSearch.url,
                            name: webSearch.name,
                            snippet: webSearch.snippet,
                            site: webSearch.site,
                            thumbnail_url: webSearch.thumbnail_url,
                            date_added: webSearch.date_added,
                            date_deleted: new Date().toISOString()
                                .split("T")[0],
                            deleted_by: editorName,
                            is_deleted: true
                        }
                    ]
                }],
            }, candidate: clickedProfile
        };
        console.log("WebSearch Delete Payload:", candidateWebSearchPayload);
        try {
            const data = await editCandidate(candidateWebSearchPayload);
            setRefresh(true);
            setIsAddWebSearch(false);
        } catch (err) {
            setError("Failed to delete websearch");
        } finally {
            // setRefresh(false);
            dispatch(creditsRefreshChanger());
        }
    };

    const handleDelete = (indexToDelete: number, item: any) => {
        const updatedList = getEditedWebSearch.filter((_, index) => index !== indexToDelete);
        console.log("To be deleted: ", item);
        handleDeleteWebSearch(item);
        setGetEditedWebSearch(updatedList); // Assuming you're managing this state
    };

    useEffect(() => {
        const editedWebSearch = getEditedField("web_search", "web_search");
        const getEditedWebSearch = [
            ...(webSearchData && Array.isArray(webSearchData.webpages) ? webSearchData.webpages : []),
            ...(Array.isArray(editedWebSearch) ? editedWebSearch : [])
        ];
        setGetEditedWebSearch(getEditedWebSearch);
    }, [webSearchData, candidateNote]);

    useEffect(() => {
        if (clickedProfile) {
            getWebSearchResult();
        }
        console.log("-------===============", webSearchData?.webpages);
    }, [clickedProfile]);

    useEffect(() => {
        console.log("Deleted Websearch Data: ", deletedWebSearchData);
        const activeWebSearches = getEditedWebSearch.filter(
            s => !deletedWebSearchData.some(
                d => d.name === s.name && d.site === s.site && d.date_added === s.date_added
            )
        );
        setGetEditedWebSearch(activeWebSearches);
    }, [deletedWebSearchData]);

    useEffect(() => {
        console.log("Candidate Notes: ", candidateNotes);
        if (candidateNotes) {
            setCandidateNote(candidateNotes);
        }
    }, [candidateNotes]);

    const handleAddWebSearch = () => {
        setIsAddWebSearch(true);
        setTimeout(() => {
            formRef.current?.scrollIntoView({ behavior: "smooth" });
        }, 100);
    };

    return (
        <div>
            <Flex align="center" className="p-[6px] w-full">
                {tooltipText ? (
                    <TooltipWrapper text={tooltipText} placement="right">
                        <div className="text-text-heading font-bold pr-2.5 text-base text-sm">Web Search:</div>
                    </TooltipWrapper>
                ) : (
                    <div className="text-text-heading font-bold pr-2.5 text-base text-sm">Web Search:</div>
                )}
            </Flex>

            <Divider style={{ margin: "0 0 8px 0" }} />

            {loading ? (
                <Spin />
                // ) : webSearchData?.webpages && webSearchData?.webpages?.length > 0 ? (
                //     webSearchData.webpages.map((exp, index) => (
            ) : getEditedWebSearch && getEditedWebSearch?.length > 0 ? (
                getEditedWebSearch.map((exp, index) => (
                    exp.edited_by !== "" ? (
                        <div key={index} className="px-[6px] mb-1">
                            {index !== 0 && <Divider style={{ margin: "8px 0" }} variant="dashed" />}
                            <div className="pl-0.5">
                                <Row align="middle">
                                    <Col className="gutter-row" span={1}>
                                        {exp.thumbnail_url ? (
                                            <a href={exp.url} target="_blank" rel="noreferrer" >
                                                <img src={exp.thumbnail_url} alt="" className="w-full h-[30px] object-contain cursor-pointer" />
                                            </a>
                                        ) : (
                                            <a href={exp.url} target="_blank" rel="noreferrer" >
                                                <div className="uppercase flex items-center justify-center w-full h-[30px] text-white cursor-pointer bg-primary text-sm">
                                                    {getSubstring(exp.name)}
                                                </div>
                                            </a>
                                        )}
                                    </Col>
                                    <Col className="gutter-row pl-2" span={22}>
                                        <TooltipWrapper text={getWebSearchToolTip(exp)!} placement="right">
                                            <div className="flex items-center gap-x-1.5 flex-wrap cursor-pointer">
                                                <a href={exp.url} target="_blank" rel="noreferrer" >
                                                    <p className="text-text-tertiary font-semibold text-sm">{exp.name}</p>
                                                </a>
                                                {/* <span className="text-text-quaternary font-medium text-xs">Engine</span>
                                        <p className="text-text-tertiary font-semibold text-sm">{exp.engine}</p> */}
                                                <img src={clockStopWatch} alt="clock" />
                                                <p className="text-text-quaternary font-medium text-xs">{exp.date_added}</p>
                                            </div>
                                        </TooltipWrapper>
                                    </Col>
                                    {
                                        isEditedWebSearch && !isAddWebSearch && (
                                            <Col span={1} className="flex justify-end items-center">
                                                <img
                                                    src={trashIcon}
                                                    alt="delete"
                                                    onClick={() => handleDelete(index, exp)}
                                                    style={{ width: 13.33, height: 13.33 }}
                                                />
                                            </Col>
                                        )
                                    }
                                    
                                </Row>
                            </div>
                        </div>
                    ) : (
                        <div key={index} className="px-[6px] mb-1">
                            {index !== 0 && <Divider style={{ margin: "8px 0" }} variant="dashed" />}
                        <div className="pl-0.5">
                                <Row align="middle">
                                    <Col className="gutter-row" span={1}>
                                        {exp.thumbnail_url ? (
                                            <a href={exp.url} target="_blank" rel="noreferrer" >
                                                <img src={exp.thumbnail_url} alt="" className="w-full h-[30px] object-contain cursor-pointer" />
                                            </a>
                                        ) : (
                                            <a href={exp.url} target="_blank" rel="noreferrer" >
                                                <div className="uppercase flex items-center justify-center w-full h-[30px] text-white cursor-pointer bg-primary text-sm">
                                                    {getSubstring(exp.name)}
                                                </div>
                                            </a>
                                        )}
                                    </Col>
                                    <Col className="gutter-row pl-2" span={22}>
                                        <div className="flex items-center gap-x-1.5 flex-wrap cursor-pointer">
                                            <a href={exp.url} target="_blank" rel="noreferrer" >
                                                <p className="text-text-tertiary font-semibold text-sm">{exp.name}</p>
                                            </a>
                                            {/* <span className="text-text-quaternary font-medium text-xs">Engine</span>
                                        <p className="text-text-tertiary font-semibold text-sm">{exp.engine}</p> */}
                                            <img src={clockStopWatch} alt="clock" />
                                            <p className="text-text-quaternary font-medium text-xs">{exp.date_added}</p>
                                        </div>
                                    </Col>
                                    <Col span={1} className="flex justify-end items-center">
                                        <img
                                            src={trashIcon}
                                            alt="delete"
                                            onClick={() => handleDelete(index, exp)}
                                            style={{ width: 13.33, height: 13.33 }}
                                        />
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    )
                ))
            ) : (
                <p>No data available</p>
            )}
            {isEditedWebSearch && !isAddWebSearch && (
                <Button type="dashed" onClick={handleAddWebSearch} className="text-xs font-semibold text-text-primary my-4">
                    + Add Web Search
                </Button>
            )}
            {isEditedWebSearch && isAddWebSearch && (
                <div ref={formRef} className="w-full mt-2">
                    <CandidateAddWebSearchForm setIsAddWebSearch={setIsAddWebSearch} editorName={editorName} candidateId={clickedProfile} setRefresh={setRefresh} loading={loading} setError={setError} />
                </div>
            )}
        </div>
    );
};

export default React.memo(WebSearch);
